// ============================================================
// useStudents Hook
// ============================================================

import { useEffect, useState } from 'react';
import useStudentStore from '@/store/studentStore';
import { useSchool } from './useSchool';

export function useStudents(initialPage = 1, initialPageSize = 20, filters = {}, options = {}) {
  const { enabled = true } = options;
  const { schoolId } = useSchool();
  
  const [page, setPage] = useState(initialPage);
  const [pageSize, setPageSize] = useState(initialPageSize);

  const students = useStudentStore((s) => s.students);
  const pagination = useStudentStore((s) => s.pagination);
  const loading = useStudentStore((s) => s.loading);
  const error = useStudentStore((s) => s.error);
  const fetchStudents = useStudentStore((s) => s.fetchStudents);

  // Stringify filters so we don't trigger infinite loops on object reference changes
  const filtersStr = JSON.stringify(filters);

  useEffect(() => {
    if (schoolId && enabled) {
      const parsedFilters = JSON.parse(filtersStr);
      fetchStudents(schoolId, page, pageSize, false, parsedFilters);
    }
  }, [schoolId, page, pageSize, filtersStr, fetchStudents, enabled]);

  return { 
    students, 
    pagination, 
    loading, 
    error, 
    page, 
    setPage, 
    pageSize, 
    setPageSize,
    refetch: () => fetchStudents(schoolId, page, pageSize, true, JSON.parse(filtersStr)) 
  };
}
